import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { ScrollManager } from './ScrollManager';
import { ProjectDrawer } from '../projects/ProjectDrawer';
import { LatestProjectsWidget } from '../latestProjects/LatestProjectsWidget';
import { ProjectDrawerProvider } from '../../contexts/ProjectDrawerContext';
export function Layout() {
  return <ProjectDrawerProvider data-id="element-400" data-mp="352bs4tzcssyt">
      <div className="flex min-h-screen w-full flex-col bg-charcoal" data-id="element-401" data-mp="3535203tlzyl6">
        <a href="#main" className="sr-only z-[100] bg-brand-action px-4 py-3 font-semibold text-white focus:not-sr-only focus:fixed focus:left-4 focus:top-4" data-id="element-402" data-mp="3a1esi14e2b0g">
          Skip to content
        </a>
        <ScrollManager data-id="element-403" data-mp="3j2d00te1d0ns" />
        <Header data-id="element-404" data-mp="1knjiyprmyyfa" />
        <main id="main" tabIndex={-1} className="flex-1 outline-none" data-id="element-405" data-mp="1ko1nsasd6kyt">
          <Outlet data-id="element-406" data-mp="1kpwbfwv0sr6l" />
        </main>
        <Footer data-id="element-407" data-mp="1oolmhisl5wn2" />
      </div>
      <ProjectDrawer data-id="element-408" data-mp="1opwqnjpy16ep" />
      <LatestProjectsWidget data-id="element-409" data-mp="1or7qx9k6jw12" />
    </ProjectDrawerProvider>;
}